// extracted by mini-css-extract-plugin
export default {"USPItem":"USPItem_AmB9q","USPItem_icon":"USPItem_icon_VhniW"};